// import '@babel/polyfill'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import "lib-flexible";
import axios from 'axios'
Vue.prototype.$axios = axios
// import './plugins/rem.js'
import "lib-flexible-computer";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import scroll from 'vue-seamless-scroll'
Vue.config.productionTip = false
Vue.use(ElementUI);
Vue.use(scroll);

// 时间格式化插件 moment.js
import moment from 'moment'
window.moment = moment;
Vue.prototype.$moment = moment;
moment.locale("zh-cn"); //需要汉化
import lodash from 'lodash'
Vue.prototype._ = lodash;

import * as echarts from "echarts";
window.echarts = echarts;
Vue.prototype.$echarts = echarts

import TRTC from 'trtc-js-sdk';
import '@/utils/audioVideo/aegis.js';
import { isMobile } from '@/utils/audioVideo/utils';
import i18n from './audioVideo/locales/i18n';

TRTC.Logger.setLogLevel(TRTC.Logger.LogLevel.DEBUG);
Vue.prototype.$isMobile = isMobile;

axios.get('./js/config.json').then((res) => {
  Vue.prototype.baseURL = res.data.baseURL; //接口请求地址
  Vue.prototype.imgURL = res.data.imgURL; //图片
  Vue.prototype.diseasesInsectPestsImgURL = res.data.diseasesInsectPestsImgURL; //病虫害图片地址
  Vue.prototype.telVerificationCode = res.data.telVerificationCode; // 登录手机验证码
  Vue.prototype.templateUrl = res.data.templateUrl; // 模型预测下载模版
  Vue.prototype.dataCenterUrl = res.data.dataCenterUrl; // 大数据中心地址
  Vue.prototype.alarmInfoUrl = res.data.alarmInfoUrl; // 预警地址
  Vue.prototype.systemHomeUrl = res.data.systemHomeUrl; //系统首页
  Vue.prototype.detailBaseImgUrl = res.data.detailBaseImgUrl;
  Vue.prototype.videoWebsocketUrL = res.data.videoWebsocketUrL;
  Vue.prototype.newSystemUrl = res.data.newSystemUrl;
  new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
  }).$mount('#app')
})

